import { FetchPurchasesOnTenderDocument, FetchPurchasesOnTenderQuery } from "@/graphql/__generated__/graphql";
import { useQuery } from "@apollo/client/react";
import { FetchPurchasesOnTenderQueryVariables } from "@/graphql/__generated__/graphql";

export const useFetchPurchasesOnTenderQueryHook = (currentTenderID: number) => {
  const { data, loading, refetch } = useQuery<FetchPurchasesOnTenderQuery, FetchPurchasesOnTenderQueryVariables>(
    FetchPurchasesOnTenderDocument, {
      variables: {
        tenderId: Number(currentTenderID)
      },
      fetchPolicy: "cache-and-network"
    });

  return {
    data, loading, refetch
  };
};
